import { useConfigContext } from '@contexts/ConfigContext'

/**
 * string literal union
 * add more here
 */
type Flag = 'maintenance.banner'

/**
 * hook to always return the requested flag or undefined
 */
export const useFlag = <
  T extends 'string' | 'number' | 'boolean',
  RT = T extends 'string'
    ? string
    : T extends 'number'
    ? number
    : T extends 'boolean'
    ? boolean
    : never
>(
  flag: Flag,
  type: T
): RT | undefined => {
  const { config } = useConfigContext()
  const req = flag.split('.')
  if (req.length !== 2) {
    return undefined
  }

  const [group, prop] = req
  const value = config?.[group]?.[prop]
  if (value === undefined) {
    return value
  }

  if (typeof value !== type) {
    return undefined
  }

  return value
}
